import * as React from "react";
import {
    IPatientAllergy,
    IPatientExamination,
    IPatientSystemiscExamination,
    IPatientSystemReview,
    IMentalStatusExamination
} from "@curefit/ehr-common";
import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { EditViewDisplayMode } from "../common/EditViewCard"
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppMessages, TabNames, ConfigConstants, QuestionType } from "../../utils/AppConstants";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import PatientVitalsSummaryBar from "../patient/summary-bar/PatientVitalsSummaryBar";
import IEditedBy from "../../models/IEditedBy";
import ISystemicExaminationStaticData from "../../models/staticData/ISystemicExaminationStaticDataValues";
import {isNull as _isNull} from "lodash"
import ErrorContainer from "../../containers/ErrorContainer";
import IMentalStatusExaminationStaticDataValue from "../../models/staticData/IMentalStatusExaminationStaticDataValue";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import IDoctorProfile from "../../models/IDoctorProfile";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import AppUtils from "../../utils/AppUtils";
import {default as CTA, CTATheme} from "../common/CallToAction";
/**
 * Created by aditya on 01/03/18.
 */

export interface PatientExaminationsTabProps {
    editedBy?: IEditedBy,
    appointmentId?: number,
    patientId: number,
    patientAllergies?: IPatientAllergy[],
    patientVitals: IPatientVitalResponse[],
    patientExaminations: IPatientExamination[],
    patientSystemicExaminations: IPatientSystemiscExamination[],
    generalExamStatics: IStaticDataValue[],
    systemicExamStatics: { [key: string]: ISystemicExaminationStaticData },
    saveEditedExaminations: (patientMedicalProfile: IPatientExamination[]) => void,
    saveEditedSystemicExaminations: (patientMedicalProfile: IPatientSystemiscExamination[]) => void,
    savePatientExaminations: (patientId: number, patientMedicalProfile: { examinations: IPatientExamination[], patientSystemicExaminations: IPatientSystemiscExamination[], mentalStatusExaminations?: IMentalStatusExamination[] }, appointmentId: number) => any,
    pastConsultations: IAppointmentScheduleResponse[],
    nextTab: () => void,
    mentalStatusExaminations: IMentalStatusExamination[],
    staticMentalStatusExaminations: { [key: string]: IMentalStatusExaminationStaticDataValue },
    saveEditedMentalStatusExaminations: (editedExams: IMentalStatusExamination[]) => void,
    doctorType: string,
    staticReviewSystemsData: IStaticDataValue[],
    saveReviewOfSystemsData: (data: IPatientSystemReview[]) => void,
    reviewOfSystemsData: IPatientSystemReview[],
    uiConfiguration: any[],
    doctorProfile: IDoctorProfile;
    isSelf: boolean,
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    typeFormMapping: any;
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>;
}

export interface PatientExaminationsTabState {
    error: string,
    isSaving?: boolean,
    errorDetails?: string,
    tabWidgets: any

}

class PatientExaminationsTab extends React.Component<PatientExaminationsTabProps, PatientExaminationsTabState> {
    private isTherapist: boolean;

    constructor(props: PatientExaminationsTabProps) {
        super(props);
        this.isTherapist = this.props.doctorType === "MIND_THERAPIST";
        this.state = {
            error: null,
            isSaving: false,
            tabWidgets: this.props.uiConfiguration.filter((widget) => widget.sectionKey === TabNames.EXAMINATIONS)
        }
    }

    componentWillUnmount() {
        this.saveEditedExaminations();
    }


    getPatientExaminationsObject = () => {
        let examinationsObject: any = {};
        examinationsObject[ConfigConstants.NEWCONFIGDATA] = {};

        this.state.tabWidgets.map((widgetData: any) => {

            examinationsObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientExaminationsTab)[widgetData.subSectionKey].getSaveObject();
            this.getFormattedObject(widgetData, examinationsObject)
        })
        return examinationsObject;
    }

    getFormattedObject = (widgetData: any, examinationsObject: any) => {
        let examinationsData: any = examinationsObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey];
        delete examinationsData.diagnosticData;
        delete examinationsData.prescriptionMedicationList;
    }


    savePatientExaminations = () => {
        let patientMedicalProfile = this.getPatientExaminationsObject();
        this.saveEditedExaminations();
        this.setState({ isSaving: true, error: null });
        this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType).then(() => {
            this.props.nextTab();
        }).catch((err: any) => {
            this.setState({
                error: AppMessages.EXAMINATIONS_SAVE_ERROR,
                errorDetails: err.message,
                isSaving: false
            })
        });
    }

    saveEditedExaminations = () => {
        let patientMedicalProfile = { ...this.props.currentMedicalProfile };
        this.state.tabWidgets.map((widgetData: any) => {
            if (patientMedicalProfile[ConfigConstants.NEWCONFIGDATA])
                patientMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientExaminationsTab)[widgetData.subSectionKey].getSaveObject();
        })
        this.props.saveEditedMedicalProfile(patientMedicalProfile);

    };

    generateScrollItems = () => {
        return [
            { name: "General Examinations", component: "general-examination-section" },
            { name: "Systemic Examinations", component: "systemic-examination-section" }
        ]
    }

    clearErrorMessage = () => {
        this.setState({
            error: null
        })
    }

    render() {
        let errorMessage = !_isNull(this.state.error) ? this.state.error : AppMessages.EXAMINATIONS_SAVE_ERROR;
        let saveButtonValue = this.state.isSaving ? "Saving..." : "Save";
        return (
            <div className="patient-history-tab-container">
                {
                    !_isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorCode={505} closeError={this.clearErrorMessage} />
                }

                {/*<ScrollToContainer componentToScroll={"ongoing-consultation-main-cont"} scrollItems={this.generateScrollItems()}/>*/}
                <div className={"sub-container"}>
                    <PatientVitalsSummaryBar patientVitals={this.props.patientVitals} patientAllergies={this.props.patientAllergies} />
                </div>

                <div className="patient-info-subsection general-examination-section">
                    {this.state.tabWidgets.map((widgetData: any, index: number) => {
                        let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, true, widgetData.subSectionKey);

                        widgetData.data.map((dataObject: any) => {
                            let labelAnswerType = dataObject.answerList && dataObject.answerList.filter((element: any) => {
                                return element.type === QuestionType.LABEL
                            });
                            if (labelAnswerType && labelAnswerType.length > 0) {
                                tabData[dataObject.key] = tabData[dataObject.key] ? tabData[dataObject.key] : {};
                                tabData[dataObject.key] = { ...tabData[dataObject.key], [labelAnswerType[0].key]: labelAnswerType[0].labelValue }
                            }
                        });
                        const modalHeaders: any = [];
                        return <div key={widgetData.subSectionKey} className="patient-info-subsection concern-section">
                            <GenericEditViewCont appointmentId={this.props.appointmentId}
                                doctorName={this.props.doctorProfile.name}
                                patientId={this.props.patientId} ref={(prescriptionLabTestDOM) => { (this as any | PatientExaminationsTab)[widgetData.subSectionKey] = prescriptionLabTestDOM }}
                                displayMode={EditViewDisplayMode.EDIT} widgetData={widgetData} tabData={tabData} fetchPatientPastSessions={this.props.fetchPatientPastSessions} modalHeaders={modalHeaders} />
                        </div>
                    })}
                </div>

                <div className={"save-button collapsible-card"}>
                    <CTA innerText={saveButtonValue} theme={CTATheme.PRIMARY} onClick={this.savePatientExaminations} customStyle={{display: "inline"}} disabled={this.state.isSaving}/>
                </div>
            </div>
        );
    }
}

export default PatientExaminationsTab